import { Icon, Stack, Typography } from '@mui/material';
import { CheckIcon } from '@schooly/style';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

export const SchoolCustomFieldsDefaultApplications: FC = () => {
  return (
    <Stack direction="row" alignItems="flex-start" gap={3}>
      <Stack gap={1} flex="0 0 260px">
        <Typography variant="h3">
          <FormattedMessage id="school-sections-CustomFields-Default-ChildrenAndParent" />:
        </Typography>

        <Stack direction="row" gap={1}>
          <Icon sx={{ color: 'primary.main' }}>
            <CheckIcon />
          </Icon>
          <Typography variant="h3">
            <FormattedMessage id="peopleDetail-GivenNames" />
          </Typography>
        </Stack>

        <Stack direction="row" gap={1}>
          <Icon sx={{ color: 'primary.main' }}>
            <CheckIcon />
          </Icon>
          <Typography variant="h3">
            <FormattedMessage id="peopleDetail-FamilyName" />
          </Typography>
        </Stack>

        <Stack direction="row" gap={1}>
          <Icon sx={{ color: 'primary.main' }}>
            <CheckIcon />
          </Icon>
          <Typography variant="h3">
            <FormattedMessage id="peopleDetail-DateOfBirth" />
          </Typography>
        </Stack>

        <Stack direction="row" gap={1}>
          <Icon sx={{ color: 'primary.main' }}>
            <CheckIcon />
          </Icon>
          <Typography variant="h3">
            <FormattedMessage id="peopleDetail-Gender" />
          </Typography>
        </Stack>

        <Stack direction="row" gap={1}>
          <Icon sx={{ color: 'primary.main' }}>
            <CheckIcon />
          </Icon>
          <Typography variant="h3">
            <FormattedMessage id="peopleDetail-Nationality" />
          </Typography>
        </Stack>
      </Stack>

      <Stack gap={1} flex="0 0 260px">
        <Typography variant="h3">
          <FormattedMessage id="school-sections-CustomFields-Default-ChildrenOnly" />:
        </Typography>

        <Stack direction="row" gap={1}>
          <Icon sx={{ color: 'primary.main' }}>
            <CheckIcon />
          </Icon>
          <Typography variant="h3">
            <FormattedMessage id="applications-PreferredStartingDate" />
          </Typography>
        </Stack>

        <Stack direction="row" gap={1}>
          <Icon sx={{ color: 'primary.main' }}>
            <CheckIcon />
          </Icon>
          <Typography variant="h3">
            <FormattedMessage id="peopleDetail-PreferredName" />
          </Typography>
        </Stack>

        <Stack direction="row" gap={1}>
          <Icon sx={{ color: 'primary.main' }}>
            <CheckIcon />
          </Icon>
          <Typography variant="h3">
            <FormattedMessage id="peopleDetail-LanguagesAndProficiency" />
          </Typography>
        </Stack>

        <Stack direction="row" gap={1}>
          <Icon sx={{ color: 'primary.main' }}>
            <CheckIcon />
          </Icon>
          <Typography variant="h3">
            <FormattedMessage id="applications-CustomFieldsDefault-MedicalNeeds" />
          </Typography>
        </Stack>

        <Stack direction="row" gap={1}>
          <Icon sx={{ color: 'primary.main' }}>
            <CheckIcon />
          </Icon>
          <Typography variant="h3">
            <FormattedMessage id="applications-CustomFieldsDefault-BehaviourConcerns" />
          </Typography>
        </Stack>

        <Stack direction="row" gap={1}>
          <Icon sx={{ color: 'primary.main' }}>
            <CheckIcon />
          </Icon>
          <Typography variant="h3">
            <FormattedMessage id="applications-CustomFieldsDefault-SpecialNeeds" />
          </Typography>
        </Stack>

        <Stack direction="row" gap={1}>
          <Icon sx={{ color: 'primary.main' }}>
            <CheckIcon />
          </Icon>
          <Typography variant="h3">
            <FormattedMessage id="applications-CustomFieldsDefault-LearningDifficulties" />
          </Typography>
        </Stack>
      </Stack>

      <Stack gap={1} flex="0 0 260px">
        <Typography variant="h3">
          <FormattedMessage id="school-sections-CustomFields-Default-ParentOnly" />:
        </Typography>

        <Stack direction="row" gap={1}>
          <Icon sx={{ color: 'primary.main' }}>
            <CheckIcon />
          </Icon>
          <Typography variant="h3">
            <FormattedMessage id="peopleDetail-PhoneNumber" />
          </Typography>
        </Stack>

        <Stack direction="row" gap={1}>
          <Icon sx={{ color: 'primary.main' }}>
            <CheckIcon />
          </Icon>
          <Typography variant="h3">
            <FormattedMessage id="peopleDetail-EmailAddress" />
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
